// extracted by mini-css-extract-plugin
export default {"container":"StudentCard_container__rMyaH","picture":"StudentCard_picture__4zGc7","name":"StudentCard_name__CAswR","chat":"StudentCard_chat__nLIbW"};